import CLIENT_STRUCT from '../client';
import AGENT_STRUCT from '../agent';

const STRUCT = {
  ...CLIENT_STRUCT,
  ...AGENT_STRUCT,
};

export default STRUCT;
